import React from "react";
import { Link } from "react-router-dom";
export default function Header() {
  function salir() {
    window.localStorage.clear();
    window.location.href='/';
  }

  return (
    <nav className="main-header navbar navbar-expand navbar-blue navbar-light">
      {/* Left navbar links */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link text-white" data-widget="pushmenu" href="#" role="button">
            <i className="fas fa-bars" />
          </a>
        </li>
        <li className="nav-item d-none">
              <marque>hola</marque>
        </li>
      </ul>
      {/* Right navbar links */}
      <ul className="navbar-nav ml-auto">
        {/* Navbar Search */}
        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="navbar-search"
            href="#"
            role="button"
          >
            <i className="fas fa-search" />
          </a>
          <div className="navbar-search-block">
            <form className="form-inline">
              <div className="input-group input-group-sm">
                <input
                  className="form-control form-control-navbar"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <div className="input-group-append">
                  <button className="btn btn-navbar" type="submit">
                    <i className="fas fa-search" />
                  </button>
                  <button
                    className="btn btn-navbar"
                    type="button"
                    data-widget="navbar-search"
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </form>
          
          </div>
        </li>
        {/* Messages Dropdown Menu */}
      
        {/* Notifications Dropdown Menu */}
   
        <li className="nav-item">
          <a
            className="nav-link text-white"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i className="fas fa-expand-arrows-alt" />
          </a>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link text-white"
            data-widget="control-sidebar"
            data-slide="true"
        
            onClick={salir}
            role="button"
          >
            
            <i className="fas fa-portal-exit" />
            Salir 
          </Link>
        </li>
      </ul>
    </nav>
  );
}
